module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/drums-444a2adcaf09374982fb1b50d78d6063.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/drums.svg
// module id = cKYs
// module chunks = 24